import { TooltipProps } from 'recharts';
import { SurveyMetricField } from './types';
import { labelBySurveyMetricField } from './constants';
import {
  DateTimeFormat,
  DateTimeFormatParse,
  formatDateTime,
  parseDate,
} from '../../../../lib/date';
import { BarChartTooltip } from '../../../../design-system/components/BarChart/BarChartTooltip';

export const renderTooltip = ({
  active,
  payload,
  label,
}: TooltipProps<number, SurveyMetricField>) => {
  if (!active || !payload || !payload.length) {
    return null;
  }

  const { value = 0, name = 'surveyViews' } = (Array.isArray(payload) && payload[0]) || {};

  const parsedDate = parseDate(label, DateTimeFormatParse.Date);
  return (
    <BarChartTooltip
      items={[
        {
          label: formatDateTime(parsedDate, DateTimeFormat.DayOfWeekWithDate),
          labelVariant: 'subtitle1',
        },
        {
          label: labelBySurveyMetricField[name],
          value: value.toString(),
          labelVariant: 'body1',
          valueVariant: 'subtitle1',
        },
      ]}
    />
  );
};
